module.exports = __webpack_public_path__ + "47bb385a73f6897c7972e86f86c5f72b.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Thin.ttf
// module id = 988
// module chunks = 0